export const updateTypes = {
  set: 'update/set',
  reset: 'update/reset',
  setGeos: 'update/setGeos',
};
